import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Dialog } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { CommonModule } from '@angular/common';
import { MeetingRepository } from '@/store/meeting-state/meeting-state.repository';
import { Checkbox } from 'primeng/checkbox';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { inviteeFormValidation } from '@/validations/meeting/invitee.validation';
import { MessageService } from 'primeng/api';
import { MeetingRoleEnum, Participant, ParticipantDto } from '@/types/meeting.types';
import { MeetingService } from '@/pages/meeting/meeting.service';

@Component({
  selector: 'sm-meeting-invitee-dialog',
  imports: [FormsModule, Dialog, Button, FormBuilderComponent, CommonModule, Checkbox, TranslateModule],
  templateUrl: './meeting-invitee-dialog.component.html',
  styleUrl: './meeting-invitee-dialog.component.scss',
})
export class MeetingInviteeDialogComponent {
  meetingRepository = inject(MeetingRepository);
  meetingService = inject(MeetingService);
  messageService = inject(MessageService);
  translate = inject(TranslateService);

  @Input() visible = false;
  @Input() sigmapFieldFormObject!: DynamicForm;
  @Input() inviteeFormObject!: DynamicForm;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() isMeetingConvened = false;

  handleActionClick() {
    const newInvitee = this.meetingRepository.get<Participant>('inviteeSelected');
    const newInviteeDto: ParticipantDto = {
      ...newInvitee,
      fonctionReunion: MeetingRoleEnum.MEMBER,
    };

    const result = inviteeFormValidation.safeParse(newInvitee);
    const meetingId = this.meetingRepository.getNested<number>('response', 'id');
    if (result.success) {
      if (this.isMeetingConvened) {
        this.meetingService.addParticipant(meetingId, newInviteeDto).subscribe({
          next: response => {
            this.meetingRepository.setNested('dto', 'participants', response);
            this.messageService.add({
              severity: 'success',
              summary: 'Succès',
              detail: this.translate.instant('meeting.message.success.added'),
            });
          },
        });
        this.resetInviteeSelected();
        this.visible = false;
        return;
      }
      const participants = this.meetingRepository.getNested<Participant[]>('dto', 'participants');
      if (participants && participants.length > 0) {
        this.meetingRepository.setNested('dto', 'participants', [...participants, newInviteeDto]);
      } else {
        this.meetingRepository.setNested('dto', 'participants', [newInviteeDto]);
      }
      this.resetInviteeSelected();
      this.visible = false;
    } else {
      this.meetingRepository.setErrors(result.error.flatten().fieldErrors);
    }
  }

  toggleVisible() {
    this.visible = !this.visible;
    this.visibleChange.emit(this.visible);
    this.resetInviteeSelected();
    this.meetingRepository.setErrors({});
  }

  inviteeType = false;

  resetInviteeSelected() {
    this.meetingRepository.set('acSelected', { name: '', code: undefined });
    this.meetingRepository.set('inviteeSelected', {
      nom: '',
      prenom: '',
      mail: '',
      fonction: '',
      organisme: '',
      present: false,
      userId: '',
    });
  }
}
